var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("label", [
        _vm._v(_vm._s(_vm.$t("workflow.vueFormBuilder.formBuilder")))
      ]),
      _vm._v(" "),
      _vm.builderElement
        ? _c("ElementObjectExtra", {
            attrs: { builderElement: _vm.builderElement, isRoot: true }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }